import classNames from 'classnames';
import { getBaseURL } from '@/features/navigation/utils/url-helpers';
import { AppNextLink } from '@/features/app-next-link';
import { PLPPages } from '@/app/(plp)/types';
import { closeMenuOnNavigate } from '../../utils/close-menu-on-navigate';
import { useLayoutMenu } from '../../utils/layout-menu';
import Title from '../title';
interface Props {
  mode: 'desktop' | 'mobile';
}
function TopBrands({
  mode
}: Props) {
  const {
    data: layoutMenu
  } = useLayoutMenu();
  return <div className={classNames('mt-4 flex-col md:mb-0 md:mt-14 md:h-[335px] md:min-w-[258px] md:border-r md:border-border-gray-medium md:pr-4', mode === 'desktop' ? 'hidden md:flex' : 'flex md:hidden')} data-sentry-component="TopBrands" data-sentry-source-file="top-brands.tsx">
            <Title text='برندهای برتر' data-sentry-element="Title" data-sentry-source-file="top-brands.tsx" />

            <ul className='mt-2 h-full space-y-1 overflow-hidden pr-2 text-sm font-normal md:mt-4 md:pr-2.5'>
                {layoutMenu?.brand?.topBrands?.map(({
        id,
        slug,
        nameFa,
        nameEn
      }) => {
        return <li key={id}>
                            <AppNextLink href={`/${getBaseURL({
            page: PLPPages.Brands,
            slug: slug || ''
          })}`} className='block pb-1.5 text-sm font-normal leading-6 text-text-darkGray' prefetch={false} onClick={closeMenuOnNavigate}>
                                <span className='text-text-darkGray'>{`${nameFa} `}</span>
                                <span className='text-text-mediumGray'>({nameEn})</span>
                            </AppNextLink>
                        </li>;
      })}
            </ul>
        </div>;
}
export default TopBrands;